module.exports = __webpack_public_path__ + "img/img34.c0e92b75.png";